import { DEFAULT_LOCALE } from 'shared/i18n';

export default (locale, path) => {
  if (locale === DEFAULT_LOCALE) {
    return path;
  }

  return `/${locale}${path}`;
};
